import { useT } from '@/shared/lib/i18n';
import { BackArrow } from '../icons/BackArrow';
import { Postit } from '../Postit';
import { RoomCodePostit } from './RoomCodePostit';

export type MobileDossierTopBarProps = {
  onBack: () => void;
  onShowRules: () => void;
  /** Render a yellow code postit between the back chip and the rules postit (online lobby only). */
  code?: string;
  codeHidden?: boolean;
  onToggleCodeHidden?: () => void;
};

/**
 * Mobile cork-stage top bar — back chip on the left, optional code
 * postit, then a pink "rules" postit on the right. Mirrors
 * `<DossierTopBar>` for mobile viewports. Shared by online lobby and
 * standalone setup.
 */
export const MobileDossierTopBar = ({
  onBack,
  onShowRules,
  code,
  codeHidden,
  onToggleCodeHidden,
}: MobileDossierTopBarProps) => {
  const t = useT();
  return (
    <div className="flex items-center justify-between gap-2">
      <button
        type="button"
        onClick={onBack}
        aria-label={t('nav.back')}
        className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-[6px] border-[1.5px] border-[var(--color-paper)]/55 bg-[rgba(255,243,223,0.10)] text-[var(--color-paper)] transition hover:bg-[rgba(255,243,223,0.22)]"
      >
        <BackArrow />
      </button>
      <div className="flex flex-shrink-0 items-center gap-1">
        {code && (
          <RoomCodePostit
            code={code}
            width={108}
            numberSize={20}
            hidden={codeHidden}
            onToggleHidden={onToggleCodeHidden}
          />
        )}
        <Postit tone="pink" rot={4} w={92} withPin onClick={onShowRules}>
          <div className="hand text-center text-[14px] text-ink leading-[1.05]">
            {t('briefing.tape.how_to_play_l1')}
            <br />
            {t('briefing.tape.how_to_play_l2')}
          </div>
        </Postit>
      </div>
    </div>
  );
};
